var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbr-plans--draft-plans"},[_c('plans-list-table',{attrs:{"loading":_vm.loading,"plans":_vm.list,"meta":_vm.listMeta,"list-for":"Draft"},on:{"loadMore":_vm.loadMore,"show":_vm.showInformations}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }